'use strict';

exports.__esModule = true;
exports.default = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _layout = require('@prisma-cms/front/lib/components/pages/layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PageLayout = function (_PrismaCmsPageLayout) {
  _inherits(PageLayout, _PrismaCmsPageLayout);

  function PageLayout() {
    _classCallCheck(this, PageLayout);

    return _possibleConstructorReturn(this, _PrismaCmsPageLayout.apply(this, arguments));
  }

  PageLayout.prototype.render = function render(content) {
    return content === null ? null : _PrismaCmsPageLayout.prototype.render.call(this, _react2.default.createElement('div', {
      style: {
        padding: "20px 10px",
        maxWidth: 1260,
        width: "100%",
        margin: "0 auto",
        height: "100%"
      }
    }, content));
  };

  return PageLayout;
}(_layout2.default);

exports.default = PageLayout;
module.exports = exports['default'];